import React from 'react'
import SettingsHook from './SettingsHook'
import { InputSwitch, InputText, Loading, SelectInput } from '../../Simple'
import { Button } from '@mui/material'
import RouterHook from '../../../contexts/RouterHook'
import { NewPassword } from '../../Modais'
import { IoChevronBackOutline } from 'react-icons/io5'

import './stylesSet.css'

const label =
  'Aqui você pode configurar quando deseja receber avisos em seu e-mail. Notificações push sempre serão enviadas, você não pode desativá-las.'

export default function DesktopSettings() {
  const serverRouter = RouterHook()
  const { sttPgStt, inpsStt, loadStt, actionsSettings } = SettingsHook()

  return (
    <div className='contain-page-settings'>
      {sttPgStt.showNewPass && (
        <NewPassword
          show={sttPgStt.showNewPass}
          ClosedModal={() => {
            actionsSettings.handleSttPgStt('showNewPass', false)
            actionsSettings.clearPassInps()
          }}
          sttSettings={{ sttPgStt, inpsStt, loadStt, actionsSettings }}
        />
      )}
      <div className='contain-titles-confgs'>
        <IoChevronBackOutline
          size={30}
          className='icon-back-arrow-cnfg'
          onClick={() => {
            serverRouter('back')
          }}
        />
        <h1>Dados Pessoais</h1>
      </div>
      {loadStt.page || loadStt.alterDados ? (
        <div className='contain-loading' style={{ height: '350px' }}>
          <Loading text={loadStt.page ? 'Carregando...' : 'Atualizando seus dados...'} />
        </div>
      ) : (
        <div className='contain-flex-setting'>
          <h1 className='sub-title-page'>Recebimento de e-mails</h1>
          <p>{label}</p>
          <div className='contain-switchs'>
            <InputSwitch
              info='Novos agendamentos'
              value={inpsStt.newReserva}
              onChange={() => actionsSettings.handleInpsStt('newReserva', !inpsStt.newReserva)}
            />
            <InputSwitch
              info='Agendamentos aprovados'
              value={inpsStt.newReservaAprovada}
              onChange={() =>
                actionsSettings.handleInpsStt('newReservaAprovada', !inpsStt.newReservaAprovada)
              }
            />
            <InputSwitch
              info='Agendamentos cancelados'
              value={inpsStt.newReservacancelada}
              onChange={() =>
                actionsSettings.handleInpsStt('newReservacancelada', !inpsStt.newReservacancelada)
              }
            />
          </div>
          <h1 className='sub-title-page'>Informações da conta</h1>
          <p>Aqui você pode editar suas informações pessoais.</p>
          <div className='contain-form-cnfg-dp'>
            <div className='div-interna-configs'>
              <InputText
                label={'Nome Completo'}
                placeHolder={'Nome Completo'}
                value={inpsStt.nome}
                onChange={e => actionsSettings.handleInpsStt('nome', e.target.value)}
                autoComplete={'name'}
              />
              <InputText
                label={'Telefone'}
                placeHolder={'Telefone'}
                value={inpsStt.telefone}
                onChange={e => actionsSettings.handleInpsStt('telefone', e.target.value)}
                maxLength={15}
                autoComplete={'tel'}
              />
              <SelectInput
                label={'Gênero'}
                value={inpsStt.genero}
                onChange={e => actionsSettings.handleInpsStt('genero', e.target.value)}
                options={[
                  { value: 'Masculino', label: 'Masculino' },
                  { value: 'Feminino', label: 'Feminino' },
                  { value: 'Não Informar', label: 'Não Informar' },
                  { value: 'Outro', label: 'Outro' },
                ]}
              />
              <InputText
                label={'Data de Nascimento'}
                placeHolder={'Data de Nascimento ex. 10/02/1995'}
                type={'date'}
                value={inpsStt.nascimento}
                onChange={e => actionsSettings.handleInpsStt('nascimento', e.target.value)}
                maxLength={10}
                autoComplete={'bday'}
              />
              <div className='contain-email-label'>
                <InputText
                  label={'E-mail'}
                  placeHolder={'E-mail'}
                  disabled={true}
                  type={'email'}
                  value={inpsStt.email}
                  autoComplete={'email'}
                  onChange={e => actionsSettings.handleInpsStt('email', e.target.value)}
                />
                {sttPgStt.showEmail && <h3>{sttPgStt.labelEmail}</h3>}
              </div>
              <div className='contain-settings-buttons'>
                <Button
                  variant='contained'
                  sx={{ marginLeft: '5px' }}
                  disabled={actionsSettings.verificaAlteracoes()}
                  onClick={() => {
                    actionsSettings.SavedChangeUser()
                  }}
                >
                  Salvar Dados
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
